import styled from "styled-components";

export const EditModalContentTech = styled.div`
  box-sizing: border-box;
`;
export const StyledEditCollabTech = styled.div<{ $numCol: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.$numCol}, 1fr);
  gap: 25px;
  width: 100%;
  padding: 12px;

  & .container-status {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 150px;
  }
`;
